import { render, staticRenderFns } from "./CardSecondSick.vue?vue&type=template&id=b779f6ca&"
import script from "./CardSecondSick.vue?vue&type=script&lang=js&"
export * from "./CardSecondSick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports